export default "__VITE_ASSET__Bad$$tyr__"